import { render, staticRenderFns } from "./owner-statement.vue?vue&type=template&id=d62f771e&scoped=true"
import script from "./owner-statement.vue?vue&type=script&lang=js"
export * from "./owner-statement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d62f771e",
  null
  
)

export default component.exports